<script>

import * as lodash from 'lodash'

import { formatPoints } from '../../services/points'

const TIER_CONFIGURATION = require('@/components/Tiering/tiering.json')

const TIER_IMAGES = [
    require('@/assets/Watermark_PiggyBank@2x.png'),
    require('@/assets/Icon_Gift_dashboard.svg'),
    require('@/assets/Watermark_Heart@2x.png')
]

class TieringFactory {
    constructor (owner) {
        this.owner = owner
        this._configuration = lodash.merge({}, TIER_CONFIGURATION)
        this._tierData = {}
        this._tierGroups = {}
    }

    get configuration () {
        return this._configuration
    }

    get tierData () {
        return this._tierData
    }

    _getTiers (tierGroups, activeTier) {
        const group = (activeTier
            ? tierGroups.find((tierGroup) => (tierGroup.findIndex((tier) => (activeTier === tier.tierId)) >= 0))
            : tierGroups[0])

        return group.reduce((acc, tier) => {
            if (this._configuration.tiers[tier.tierId]) {
                const data = lodash.merge({}, this._configuration.tiers[tier.tierId])
                acc.push(lodash.merge(data, tier))
            }

            return acc
        }, [])
    }

    mergeConfiguration (value) {
        lodash.merge(this._configuration, value)
    }

    mergeTierData (data, primaryKey) {
        const tiers = {}

        data.forEach((tier) => {
            tiers[tier[primaryKey]] = tier
        })

        lodash.merge(this._tierData, tiers)
    }

    mergeTierGroups (value) {
        lodash.merge(this._tierGroups, value)
    }

    build (activeTier, pointsAcquired) {
        if (activeTier == null) {
            activeTier = ''
        }

        pointsAcquired = Number(pointsAcquired) || 0

        const tierGroups = this._configuration.groups.reduce((acc1, group) => {
            if (!this._tierGroups[group.entity] || !group.available) return acc1

            const tiers = this._getTiers(group.tiers, activeTier)
            const tiering = tiers.map((tier, tierIndex) => {
                const tmp = lodash.merge({}, tier)
                lodash.merge(tmp, this._configuration.templates[tier.template])
                if (this._tierData[tmp.tierId]) {
                    lodash.merge(tmp, this._tierData[tmp.tierId])
                }

                tmp.pointsToNextTierCurrency = formatPoints((Number(tmp.pointsToNextTier) || 0))
                tmp.redemptionLimit = this.owner.$options.filters.numeral((Number(tmp.redemptionLimit) || 0), '0%')
                tmp.rewardsExpireInDays = this.owner.$options.filters.numeral((Number(tmp.daysToExpire) || 0), '0')
                tmp.rewardsExpireInMonths = this.owner.$options.filters.numeral((Number(tmp.daysToExpire) || 0) / 30, '0')
                tmp.rewardsExpireInYears = this.owner.$options.filters.numeral((Number(tmp.daysToExpire) || 0) / 365, '0')
                tmp.spendWithinPeriodDays = this.owner.$options.filters.numeral((Number(tmp.spendWithinPeriod) || 0), '0')
                tmp.spendWithinPeriodMonths = this.owner.$options.filters.numeral((Number(tmp.spendWithinPeriod) || 0) / 30, '0')
                tmp.spendWithinPeriodYears = this.owner.$options.filters.numeral((Number(tmp.spendWithinPeriod) || 0) / 365, '0')
                tmp.tierThresholdCurrency = formatPoints(Number(tmp.tierThreshold) || 0)

                tmp.pointsAcquired = Number(pointsAcquired) || 0

                if (tmp.bullets) {
                    tmp.bullets = tmp.bullets.map((bullet) => {
                        return this.$t(tmp.context + '.' + bullet, tmp)
                    })
                } else if (tmp.bulletPrefix) {
                    let bulletIndex = 0
                    const bullets = []
                    let bullet
                    do {
                        ++bulletIndex

                        bullet = getBulletText.call(this.owner, tmp, [
                            group.configuration.context + '.' + tmp.bulletPrefix + bulletIndex,
                            'tieringCommon.' + tmp.bulletPrefix + bulletIndex
                        ])

                        if (bullet != null) {
                            bullets.push(bullet)
                        } else {
                            break
                        }
                    } while (bulletIndex < 65)

                    tmp.bullets = bullets
                }

                tmp.watermark = TIER_IMAGES[tierIndex % TIER_IMAGES.length]

                return tmp
            })

            if (tiering.length > 0) {
                const tierGroup = {
                    configuration: group.configuration,
                    tiers: tiering
                }

                acc1.push(tierGroup)
            }

            return acc1
        }, [])

        return tierGroups
    }
}

export default {
    methods: {
        createTieringFactory () {
            return new TieringFactory(this)
        }
    }
}

function getBulletText (tier, translationKeyOrder) {
    let bullet

    translationKeyOrder.find((key) => {
        const translation = this.$nsLanguage.getTranslation(key, tier)
        if (translation !== key) {
            bullet = translation
            return true
        }

        return false
    })

    return bullet
}

</script>
